<script lang="ts">
    import { tick } from 'svelte'
    import type { Writable } from 'svelte/store'

    import Date from 'hydria/components/Date.svelte'
    import { gettext as _ } from 'hydria/services/gettext'

    import type { Zone, ZoneRevision } from 'wdom/zone/zone'

    interface Props {
        status: Writable<'loading' | 'ready' | 'not-found' | 'error'>
        zone: Writable<Zone | undefined>
        busy: Writable<boolean | string>
        currentRevision: Writable<number | undefined>
        zoneRevisions: Writable<ZoneRevision[]>
        loadSaved: () => void
        loadRevision: (n: number) => void
    }

    let { status, zone, busy, currentRevision, zoneRevisions: revisions, loadSaved, loadRevision }: Props = $props()

    let currentElement: HTMLElement | undefined = $state(),
        listElement: HTMLElement | undefined = $state()

    let positionned = $state(false)
    $effect(() => {
        if (currentElement && listElement && !positionned)
            tick().then(() => {
                if (!positionned && currentElement && listElement) {
                    positionned = true
                    listElement.scrollTo({ left: 0, top: currentElement.offsetTop - listElement.offsetTop - 1, behavior: 'smooth' })
                }
            })
    })
</script>

<style>
    #z-rev {
        display: flex;
        flex-direction: column;
        height: 100%;
    }
    .card {
        flex: 1 1 0;
    }
    .card-body {
        display: flex;
        flex-direction: column;
    }
    .revision-list {
        flex: 1 1 0;
        /* max-height: 155px; */
        overflow-y: scroll;
        margin-bottom: 0;
        font-size: 0.95em;
    }
    .rev:last-child {
        margin-bottom: 3px;
    }
</style>

{#if $status == 'ready'}
    <div id="z-rev">
        <div class="standalone-title text-primary">{$_('Old revisions')}</div>
        <div class="card">
            <div class="card-body">
                {#if $busy}
                    <div class="transparent-cover"></div>
                {/if}
                <div class="top-shadow"></div>
                <ol class="revision-list" bind:this={listElement}>
                    {#each $revisions as revision}
                        {#if $zone && revision.revision == $zone.revision}
                            <li class="rev" value={revision.revision}>
                                <a
                                    href="/"
                                    onclick={(e) => {
                                        e.preventDefault()
                                        loadSaved()
                                    }}
                                    bind:this={currentElement}
                                    class:text-danger={revision.revision == $currentRevision}><Date value={revision.stamp} format="h-table-s" /></a
                                >
                            </li>
                        {:else}
                            <li class="rev" value={revision.revision}>
                                <a
                                    href="/"
                                    onclick={(e) => {
                                        e.preventDefault()
                                        loadRevision(revision.revision)
                                    }}
                                    class:text-danger={revision.revision == $currentRevision}><Date value={revision.stamp} format="h-table-s" /></a
                                >
                            </li>
                        {/if}
                    {/each}
                </ol>
            </div>
        </div>
    </div>
{/if}
